const checkValidEmail = value => {
  const filter =
    /^([+\w-]+(?:\.[+\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
  return filter.test(value);
};

export default checkValidEmail;
